<template>
    <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-menu
                                ref="dateMenu"
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs  }">
                                <v-text-field
                                        v-model="date"
                                        label="Data przepustki"
                                        prepend-icon="fa-calendar-alt"
                                        id="date"
                                        name="date"
                                        readonly
                                        v-validate="'required'"
                                        v-bind="attrs"
                                        :error-messages="errors.collect('date')"
                                        data-vv-as="Data przepustki"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title scrollable locale="pl-PL"
                                           @input="dateMenu = false">
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <TimePicker v-model="startTime" text="Początek"></TimePicker>
                    </v-col>
                    <v-col cols="6">
                        <TimePicker v-model="endTime" text="Koniec"></TimePicker>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="save()" color="success">Zapisz</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="closeForm()" color="error">Zamknij</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import swal from "sweetalert";
    import TimePicker from "@/components/shared/TimePicker.vue";
    import dayjs from "dayjs";
    import {therapistsService} from "../../services";
    export default {
        name: "AddEditQuickBreak",
        data() {
            return {
                date: null,
                title: 'Dodawanie przepustki',
                dateMenu: false,
                startTime: null,
                endTime: null,
            }
        },
        props: ["therapistID"],
        components: {TimePicker},
        methods: {
            save() {
                if(!this.date)
                {
                    this.showError(false,'Nie wybrano daty przepustki.')
                }
                if(!this.startTime || !this.endTime)
                {
                    this.showError(false,"Godzina początkowa i końcowa muszą być określone.")
                    return
                }

                let startDate = this.date + " " + this.startTime ;
                let endDate = this.date + " " + this.endTime ;
                let dj = new dayjs(startDate)
                let dj2 = new dayjs(endDate)

                if(dj >= dj2)
                {
                    this.showError(false,'Godzina początkowa nie może być wieksza niż końcowa.')
                    return
                }
                therapistsService.AddShortBreak({timeStart: startDate, timeEnd: endDate, therapistId: this.therapistID}).then(()=> {
                    this.closeForm()
                }).catch((error) => {
                  let err =error.response
                  if(err.data != null && err.data.error && err.data.error.message)
                  {
                    this.showError(false,err.data.error.message)
                  }
                  else
                  {
                    this.showError(false,"Nie można zapisać przerwy")
                  }
                })
            },
            closeForm() {
                this.$emit('close')
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>